//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import config from 'config';

// Modules
import NotificationModal from 'shared-component/modal/notification-modal';

export class ShowOrganizerLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showChannelLogoEdit: false,
            showChannelLogoEditMobile: false
        };

        this.removeLogoBlurStyle = {
            backgroundImage: `url(${this.props.channelLogo})`,
            backgroundPosition: '0px 40px',
            backgroundSize: 'cover'
        };
    }

    staticChannelLogoEditMouseOver() {
        this.setState({showChannelLogoEdit: true});
    }

    staticChannelLogoEditMouseLeave() {
        this.setState({showChannelLogoEdit: false});
    }

    removeLogoModalClicked() {
        this.setState({showChannelLogoEditMobile: true});
    }

    showRemoveLogoModal() {
        const {t} = this.props;
        const showModal = true;
        const styles = {
            img: {
                width: '100px',
                height: '100px'
            },
            body: {
                display: 'block',
                marginBottom: '20px'
            }
        };
        const deleteLogoActions = [
            {
                onClick: () => {
                    this.props.onClick();
                },
                text: t('button.ok')
            }
        ];
        const modalHeader = <img alt="Channel Logo" style={styles.img} src={this.props.channelLogo} />;
        const modalInstruction = <span style={styles.body}>{t('channel.logo.modal-text')}</span>;
        return (
            <NotificationModal
              show={showModal}
              header={modalHeader}
              onExited={() => { this.setState({...this.state, showChannelLogoEditMobile: false}); }}
              actions={deleteLogoActions}
              instruction={modalInstruction}
            />
        );
    }

    render() {
        const {t} = this.props;
        return (
            <div
              className="channelLogo"
              onMouseEnter={this.staticChannelLogoEditMouseOver.bind(this)}
              onMouseLeave={this.staticChannelLogoEditMouseLeave.bind(this)}
            >
                <img alt="Channel Logo" src={this.props.channelLogo} />
                {
                    this.state.showChannelLogoEdit ?
                        <div onClick={this.props.onClick} className="remove-logo--span">
                            <span className="remove-logo--blur" style={this.removeLogoBlurStyle}></span>
                            <img
                              src={`${config.assets.url}/images/catalog/remove-logo.png`}
                              alt="Remove your channel logo"
                              className="remove-logo--img"
                            />
                            <span className="remove-logo--text">{t('channel.logo.remove')}</span>
                        </div> : ''
                }
                <span className="remove-logo--span-mobile" onClick={this.removeLogoModalClicked.bind(this)}></span>
                {
                    this.state.showChannelLogoEditMobile ?
                        this.showRemoveLogoModal() : ''
                }
            </div>
        );
    }
}

ShowOrganizerLogo.propTypes = {
    channelLogo: PropTypes.string,
    onClick: PropTypes.func,
    t: PropTypes.func,
};

export default translate(['translation'])(ShowOrganizerLogo);




// WEBPACK FOOTER //
// ./src/components/SharedComponents/logo/showOrganizerLogo.js